let newOptionPinned = false;
let listeners = [];



// example of expected data =  data = {
//     id : 1
//     viewName : "Inventory Manegement",
//     accessPath : "baseUrl/store/inventory-management",
//     parentModule : "Store Module",
//     iconName : InventoryManagementIcon 
// }

export const pinOption = (data) => {
    const pinnedOptions = localStorage.getItem("_pinnedOpts") ? JSON.parse(localStorage.getItem("_pinnedOpts")) : [];

    const optionExist = pinnedOptions.some((el) => el.id == data.id)
    if (!optionExist) {
        if (data) {
            if (data.id && data.viewName && data.accessPath && data.parentModule && data.iconName) {
                let newOptionData = [...pinnedOptions, data]
                localStorage.setItem("_pinnedOpts", JSON.stringify(newOptionData))
            } else {
                throw new Error("The data expected by pinOption Method appears be incomplete or undefined , please review where you are implementing this method")
            }
        } else {
            throw new Error("error getting data parameter")
        }
    }


}

export const saveModuleSelectedId = (modId) => {
    localStorage.setItem("mod_id", modId);
}

export const getModuleSelectedId = () => {
    let modId = localStorage.getItem("mod_id");
    if (modId) {
        return modId
    }
}

export function localStorageSave(prefix, params, data) {
    const userId = localStorage.getItem('u_id');
    if (Boolean(userId)) params.userId = userId;
    localStorage.setItem(`${prefix}?${new URLSearchParams(params).toString()}`, JSON.stringify(data));
}

export function localStorageGet(prefix, params) {
    const userId = localStorage.getItem('u_id');
    if (Boolean(userId)) params.userId = userId;

    return Object.keys(localStorage)
        .filter(key => key.startsWith(prefix)) // Filter by prefix and userId
        .filter(key => {
            const storedParams = key.split('?')[1]; // Extract the query params part
            return validateParams(params, storedParams);
        })
        .map(key => JSON.parse(localStorage.getItem(key) ?? {}));
}

export function localStorageGetContent(prefix, params, orderBy){
    const userId = localStorage.getItem('u_id');
    if (Boolean(userId)) params.userId = userId;
    let items = {}; 
    Object.keys(localStorage).filter(key=> key.startsWith(prefix) && validateParams(params,  key.split('?')[1])).forEach(key => {
        let params2 = new URLSearchParams(key.split('?')[1]);
        items[params2.get(orderBy)] = JSON.parse(localStorage.getItem(key));
    });
    return items;
}

export function localStorageGetSections(prefix, params, orderBy) {
    const userId = localStorage.getItem('u_id');
    if (Boolean(userId)) params.userId = userId;
    let items = {}; 
    Object.keys(localStorage).filter(key=> key.startsWith(prefix) && validateParams(params,  key.split('?')[1])).forEach(key => {
        let params2 = new URLSearchParams(key.split('?')[1]);
        items[params2.get(orderBy)] = {...(items[params2.get(orderBy)]), ...Object.fromEntries(key.split('?')[0].split('/').map(section => [section, true]))}
    });
    return items;


}

// export function localStorageGetSections(prefix, params) {
//     const userId = localStorage.getItem('u_id');
//     if (Boolean(userId)) params.userId = userId;

//     return Object.keys(localStorage)
//         .filter(key => key.startsWith(prefix)) // Match the prefix
//         .filter(key => {
//             const queryParams = new URLSearchParams(key.split('?')[1]);
//             // Remove 'id' from params, and compare the rest of the query params
//             for (let [key, value] of Object.entries(params)) {
//                 if (queryParams.get(key) !== value) return false;
//             }
//             return true;
//         })
//         .reduce((acc, key) => {
//             const [path, queryString] = key.split('?');
//             const queryParams = new URLSearchParams(queryString);
//             const id = queryParams.get('id');
//             const part = path.split('/').pop(); // Extract the last part of the path

//             // Group by id
//             if (!acc[id]) acc[id] = [];
//             acc[id].push(part);

//             return acc;
//         }, {});
// }

export function localStorageRemove(prefix, params) {
    const userId = localStorage.getItem('u_id');
    if (Boolean(userId)) params.userId = userId;
    Object.keys(localStorage)
        .filter(key => key.startsWith(prefix)) // Filter by prefix and userId
        .filter(key => {
            const storedParams = key.split('?')[1]; // Extract the query params part
            return validateParams(params, storedParams);
        })
        .forEach(key => localStorage.removeItem(key));
}

function validateParams(query, targetParams) {
    // Create a URLSearchParams object from itemParams
    const targetParamsObj = new URLSearchParams(targetParams);

    // Check if all keys and values in query exist in itemParamsObj
    return Object.keys(query).every(key => {
        return targetParamsObj.get(key)?.toString() === query[key]?.toString();
    });
}